import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Conduiteprojet.css";
import Breadcrumb from './Breadcrumb';
import CallToAction from './CallToAction';


const ConduiteProjet = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    telephone: "",
    entreprise: "",
    date: "",
    message: ""
  });

  // État pour les données du hero (titre et description de la rubrique)
  const [heroData, setHeroData] = useState({
    title: "Conduite de projet orientée valeur",
    subtitle: "Nous accompagnons les organisations dans la conduite de leurs projets, depuis la phase de cadrage jusqu'à la mise en production, avec une attention particulière portée à la création de valeur métier.",
    text: "Notre approche intègre les bonnes pratiques de gestion de projet afin de garantir des solutions alignées sur les besoins réels des bénéficiaires et des parties prenantes."
  });

  // Fonction pour nettoyer le HTML
  const cleanText = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Fonction pour extraire les éléments d'une liste HTML
  const extractListItems = (html) => {
    if (!html) return [];
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const items = [];
    tempDiv.querySelectorAll('li').forEach(li => {
      const text = li.textContent || li.innerText;
      if (text && text.trim()) {
        items.push(text.trim());
      }
    });
    return items;
  };

  useEffect(() => {
    fetchConduiteData();
  }, []);

  const fetchConduiteData = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Conduite-de-projets-1`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const rubriqueData = data.data;

        // // 1. Mettre à jour les données du hero
        // setHeroData({
        //   title: cleanText(rubriqueData.titre) || "Conduite de projet orientée valeur",
        //   subtitle: cleanText(rubriqueData.soustitre) || "Nous accompagnons les organisations dans la conduite de leurs projets...",
        //   text: cleanText(rubriqueData.descriptif) || "Notre approche intègre les bonnes pratiques de gestion de projet..."
        // });

        // 2. Récupérer les articles (interventions et résultats)
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          rubriqueData.articles.forEach((article) => {
            const title = cleanText(article.titre);
            const content = article.texte || article.descriptif || article.soustitre || "";

            // Si le titre contient "intervention" ou équivalent
            if (title.toLowerCase().includes("Nos interventions") || title === "Nos interventions") {
              const items = extractListItems(content);
              if (items.length > 0) {
                setInterventions(items);
              }
            }
            // Si le titre contient "résultat" ou équivalent
            else if (title.toLowerCase().includes("Nos résultats") || title === "Nos résultats" || title.toLowerCase().includes("Nos résultats")) {
              const items = extractListItems(content);
              if (items.length > 0) {
                setResults(items);
              }
            }
          });
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }

    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulaire RDV soumis:", formData);
    alert("Merci ! Nous vous contacterons pour fixer un rendez-vous dans les plus brefs délais.");
    setIsModalOpen(false);
    setFormData({
      nom: "",
      email: "",
      telephone: "",
      entreprise: "",
      date: "",
      message: ""
    });
  };


  // const interventions = [
  //   "Cadrage des projets et définition des objectifs",
  //   "Recueil, analyse et formalisation des besoins (Business Analysis)",
  //   "Rédaction des spécifications fonctionnelles et techniques",
  //   "Pilotage de projets en cycle agile ou hybride",
  //   "Coordination des équipes métiers et techniques",
  //   "Suivi des livrables et gestion des changements",
  //   "Accompagnement à la mise en production"
  // ];

  // const results = [
  //   "Des solutions adaptées aux besoins métier",
  //   "Une meilleure maîtrise des délais et des livrables",
  //   "Une communication fluide entre les parties prenantes",
  //   "Une réduction des écarts entre besoin exprimé et solution livrée"
  // ];

  const [interventions, setInterventions] = useState([]);

  const [results, setResults] = useState([]);

  return (
    <>
      <Breadcrumb />
      <div className="conduite-page">
        {/* Hero Section */}
        <div className="conduite-page-hero">
          <div className="conduite-page-hero-overlay"></div>
          <div className="conduite-page-hero-content">
            <h1 className="conduite-page-hero-title">{heroData.title}</h1>
            <p className="conduite-page-hero-subtitle">
              {heroData.subtitle}
            </p>
            <p className="conduite-page-hero-text">
              {heroData.text}
            </p>
          </div>
        </div>

        {/* Nos Interventions */}
        <div className="conduite-page-interventions">
          <div className="conduite-page-section-content">
            <h2 className="conduite-page-section-title">Nos interventions couvrent :</h2>

            <div className="conduite-page-list-container">
              <ul className="conduite-page-list">
                {interventions.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Résultats Attendus */}
        <div className="conduite-page-results">
          <div className="conduite-page-section-content">
            <h2 className="conduite-page-section-title">Résultats attendus :</h2>

            <div className="conduite-page-list-container">
              <ul className="conduite-page-list conduite-page-list-results">
                {results.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        {/* <div className="conduite-page-cta">
          <div className="conduite-page-cta-content">
            <button className="conduite-page-cta-button" >
              Demander un RDV
            </button>
          </div>
        </div> */}

        <CallToAction
          title="Prêt à collaborer avec nous ?"
          // button1Text="Ecrire WhatsApp"
          button2Text="Demander RDV"
          // onButton1Click={() => window.open('https://wa.me/2290158585050', '_blank')}
          // onButton2Click={() => navigate('/contact')}
          // button1Icon={<FaWhatsapp />}
        />

        {/* Modal Formulaire RDV */}
        {isModalOpen && (
          <div className="conduite-page-modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div className="conduite-page-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="conduite-page-modal-close" onClick={() => setIsModalOpen(false)}>✕</button>
              <h2>Demande de rendez-vous</h2>
              <p>Remplissez ce formulaire et nous vous contacterons pour planifier un rendez-vous</p>

              <form onSubmit={handleSubmit} className="conduite-page-rdv-form">
                <div className="conduite-page-form-group">
                  <label>Nom complet *</label>
                  <input
                    type="text"
                    name="nom"
                    value={formData.nom}
                    onChange={handleInputChange}
                    required
                    placeholder="Votre nom"
                  />
                </div>

                <div className="conduite-page-form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="votre@email.com"
                  />
                </div>

                <div className="conduite-page-form-group">
                  <label>Téléphone *</label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleInputChange}
                    required
                    placeholder="Votre numéro"
                  />
                </div>

                <div className="conduite-page-form-group">
                  <label>Entreprise</label>
                  <input
                    type="text"
                    name="entreprise"
                    value={formData.entreprise}
                    onChange={handleInputChange}
                    placeholder="Nom de votre entreprise"
                  />
                </div>

                <div className="conduite-page-form-group">
                  <label>Date préférentielle</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="conduite-page-form-group">
                  <label>Message (optionnel)</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Décrivez brièvement votre projet..."
                  ></textarea>
                </div>

                <button type="submit" className="conduite-page-submit-button">
                  Demander un rendez-vous
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConduiteProjet;